import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = '查看全部' }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-6 md:h-7 rounded-full bg-accent-500"></span>
        <div>
          <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-600 mt-1">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="text-sm text-primary-700 hover:text-accent-600 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}